import { AnimatePresence, motion, MotionConfig } from "framer-motion";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import useCustomizerStore from "../../../state/customizer";
import useTransitionStore from "../../../state/transitions";
import { isMobile, useMobileOrientation } from "react-device-detect";
import alert from "../../../assets/images/alert.svg";
import closeBtn from "../../../assets/images/closeBtn.svg";
import SuspensionUI from "./SuspensionUI";
import { exteriorHotspotLocations } from "../../../util/hotspotData";

const SelectedHotspotDescription = () => {
  const [hotspotRemoved, setHotspotRemoved] = useState(false);
  const [showHotspotCopy, setShowHotspotCopy] = useState(false);
  const [showDisclaimerAlert, setShowDisclaimerAlert] = useState(false);
  const [title, setTitle] = useState(selectedHotspotTitle);
  const [description, setDescription] = useState(selectedHotspotDescription);
  const { isLandscape } = useMobileOrientation();
  const {
    selectedDisclaimer,
    setSelectedDisclaimer,
    disclaimerOpen,
    setDisclaimerOpen,
    selectedHotspotTitle,
    selectedHotspotDescription,
    setSelectedHotspotDescription,
    setSelectedHotspotTitle,
    futureSelectedHotspotTitle,
    futureSelectedHotspotDescription,
    futureSelectedDisclaimer,
    model,
    selectionByModel,
  } = useCustomizerStore();
  const DisplayMode = useTransitionStore((s) => s.DisplayMode);
  const SuspensionMode = useTransitionStore((s) => s.SuspensionMode);
  const WheelIndex = selectionByModel?.[model]?.wheel ?? 0;

  useEffect(() => {
    setHotspotRemoved(true);
  }, [futureSelectedHotspotTitle]);

  useEffect(() => {
    if (hotspotRemoved) {
      const timer = setTimeout(() => {
        setHotspotRemoved(false);
        setSelectedHotspotDescription(futureSelectedHotspotDescription);
        setSelectedHotspotTitle(futureSelectedHotspotTitle);
        setSelectedDisclaimer(futureSelectedDisclaimer);
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [hotspotRemoved]);

  useEffect(() => {
    setSelectedHotspotDescription(futureSelectedHotspotDescription);
    setSelectedHotspotTitle(futureSelectedHotspotTitle);
    setSelectedDisclaimer(futureSelectedDisclaimer);
  }, []);

  useEffect(() => {
    if (!selectedHotspotTitle) {
      setShowHotspotCopy(false);

      setTimeout(() => {
        setShowDisclaimerAlert(false);
      }, 600);
    }

    if (showHotspotCopy) {
      setShowHotspotCopy(false);

      setTimeout(() => {
        if (selectedHotspotTitle) {
          setTitle(selectedHotspotTitle);
          setDescription(selectedHotspotDescription);
          setShowHotspotCopy(true);

          if (selectedDisclaimer.length) {
            setShowDisclaimerAlert(true);
          } else {
            setShowDisclaimerAlert(false);
          }
        }
      }, 600);
    } else {
      if (selectedHotspotTitle) {
        setTitle(selectedHotspotTitle);
        setDescription(selectedHotspotDescription);
        setShowHotspotCopy(true);

        if (selectedDisclaimer.length) {
          setShowDisclaimerAlert(true);
        } else {
          setTimeout(() => {
            setShowDisclaimerAlert(false);
          }, 600);
        }
      }
    }
  }, [selectedHotspotTitle]);

  return (
    <>
      <HotspotContainer
        alertBottom={isMobile ? "40px" : null}
        alertLeft={isMobile ? "88%" : null}
        alertWidth={isMobile ? "20px" : null}
        bottom={
          isMobile
            ? isLandscape
              ? DisplayMode == "powertrain"
                ? "0px"
                : "40px"
              : DisplayMode == "powertrain" ||
                (DisplayMode == "interior" && model !== 1)
              ? "0px"
              : SuspensionMode
              ? "0px"
              : "45px"
            : null
        }
        padding={
          isMobile
            ? DisplayMode == "powertrain"
              ? "0 18px 70px 18px"
              : "0 18px 50px 18px"
            : null
        }
        isMobile={isMobile}
      >
        <MotionConfig transition={{ duration: 0.6 }}>
          <AnimatePresence>
            {selectedDisclaimer.length > 0 && disclaimerOpen && (
              <>
                {!isMobile && (
                  <motion.div
                    key="desktop-disclaimer"
                    className="disclaimer"
                    onClick={() => setDisclaimerOpen(false)}
                    initial={{ opacity: 0, x: -600 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: -600 }}
                  >
                    <div className="x" onClick={() => setDisclaimerOpen(false)}>
                      <img src={closeBtn} />
                    </div>
                    <p>{selectedDisclaimer}</p>
                  </motion.div>
                )}
              </>
            )}
            {showHotspotCopy && (
              <motion.div
                className="container"
                key="selected-hotspot-container"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: 30 }}
              >
                <div
                  style={{
                    fontSize: isMobile ? "22px" : "32px",
                    color: "#FFFCF9",
                    margin: "0",
                    marginBottom: isMobile ? "2px" : "10px",
                  }}
                >
                  {title == "Available 21” Premium Alloy Wheels"
                    ? WheelIndex == 0
                      ? "19” Multi-spoke Two-tone Alloy Wheels"
                      : title
                    : title}
                </div>
                <div
                  className="description"
                  style={{
                    marginBottom: "10px",
                    fontSize: isMobile ? "11px" : "auto",
                  }}
                >
                  {title == "Available 21” Premium Alloy Wheels"
                    ? WheelIndex == 0
                      ? "19-in. multi-spoke machined-finish two-tone alloy wheels elegantly complement the sedan’s dynamic style."
                      : description
                    : description}
                  {showDisclaimerAlert && (
                    <motion.div
                      key="disclaimer-alert"
                      className="alert"
                      onClick={() => setDisclaimerOpen(!disclaimerOpen)}
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      exit={{ opacity: 0 }}
                    >
                      <img src={alert} />
                    </motion.div>
                  )}
                </div>
                {isMobile && <SuspensionUI />}
              </motion.div>
            )}
          </AnimatePresence>
        </MotionConfig>
      </HotspotContainer>
      <MotionConfig transition={{ duration: 0.6 }}>
        <AnimatePresence>
          {isMobile && DisplayMode == "interior" && showHotspotCopy && (
            <MobileInteriorGradient
              key="mobile-interior-gradient"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 30 }}
              limited={model == 1}
            />
          )}
        </AnimatePresence>
      </MotionConfig>
    </>
  );
};

const MobileInteriorGradient = styled(motion.div)`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: -1;
  height: ${({ limited }) => (limited ? "400px" : "300px")};
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.58) 51.56%,
    rgba(0, 0, 0, 0.8) 100%
  );
`;

const HotspotContainer = styled.div`
  max-width: 600px;
  width: auto;
  height: auto;
  bottom: ${(props) => props.bottom || "0"};
  padding: ${(props) => props.padding || "0"}; //50px
  color: #fffcf9;
  position: absolute;
  z-index: 99999999;

  .disclaimer {
    position: relative;
    width: 600px;
    background-color: #000;
    padding: 20px 50px 20px 50px;
    font-size: 16px;
    font-style: italic;
    box-sizing: border-box;
    .x {
      pointer-events: auto;
      cursor: pointer;
      position: absolute;
      top: 10px;
      right: 10px;
      img {
        width: 40px;
        height: 40px;
        transition: scale 0.2s ease-in-out;
      }
      &:hover {
        img {
          scale: 1.1;
          transition: scale 0.2s ease-in-out;
        }
      }
    }
  }
  .container {
    padding: ${({ isMobile }) => (isMobile ? "0" : "30px 0 30px 50px")};
    box-sizing: border-box;
    .description {
      display: flex;
      gap: 20px;
      .alert {
        align-self: flex-end;
        pointer-events: auto;
        width: 28px;
        height: 28px;
        cursor: pointer;
        img {
          width: ${(props) => props.alertWidth || "27.5px"};
          transition: scale 0.2s ease-in-out;
        }

        &:hover {
          img {
            scale: 1.2;
            transition: scale 0.2s ease-in-out;
          }
        }
      }
    }
  }
`;

export default React.memo(SelectedHotspotDescription);
